export default __webpack_public_path__ + "static/media/image-009.33533e97.jpg";